import { ID_TOKEN_TYPE_HINT } from '../../constants/common-enums';
/**
 * Get ID token from the list of issued token in the Spawn response
 * @param {array} issuedTokens
 * @returns {string} token
 */
export const getIdToken = issuedTokens => {
  if (issuedTokens && Array.isArray(issuedTokens)) {
    const idToken = issuedTokens.find(iToken =>
      ID_TOKEN_TYPE_HINT.includes(iToken.token_type_hint)
    );
    return (idToken && idToken.token) || null;
  }
  return null;
};
